var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"catalog-quick-filter rounded px-2 py-2 d-flex flex-align-center",class:{ 'selected text-white bg-default-5': _vm.isSelected },attrs:{"href":_vm.url},on:{"click":_vm.fetch}},[_c('div',{staticClass:"mr-1"},[_c(_vm.iconsMap[_vm.value],{tag:"component"})],1),_vm._v("\n    "+_vm._s(_vm.label)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }